<template functional>
  <div>
    <el-tag
      v-if="props.column === 'ObjectiveCombinedId'"
      :class="{
        Strategyc: $options.isStrategic(props),
        Operational: $options.isOperational(props),
        blink:
          $options.NoTasks(props) ||
          (props.row.ExecutionPercentage < 100
            ? $options.outdated(props, $options.actualDate)
            : false),
        outdated:
          props.row.ExecutionPercentage < 100
            ? $options.outdated(props, $options.actualDate)
            : false,
        closedInTime: props.row.ExecutionPercentage === 100
      }"
      >{{ props.rowValue }}</el-tag
    >
  </div>
</template>

<script>
export default {
  name: "BlinkingObjective",
  actualDate: new Date(),
  isStrategic(props) {
    let result;
    result = props.row.TypeStrategic === 2;
    return result;
  },
  isOperational(props) {
    let result;
    result = props.row.TypeStrategic === 1;
    return result;
  },
  NoTasks(props) {
    let result;
    result = props.row.TasksCount === 0;
    return result;
  },

  outdated(props, today) {
    console.log("outdated: ", props);
    let result;
    result = new Date(props.row.DateEnd) < today;
    return result;
  }
};
</script>

<style lang="scss" scoped>
.Strategyc {
  background-color: rgba(220, 168, 240, 0.6); /* light purple */
  color: purple; /* texto morado más oscuro para contraste */
  border-color: purple;
}
.Operational {
  background-color: rgba(240, 234, 168, 0.6); /* light purple */
  color: darkgoldenrod; /* texto morado más oscuro para contraste */
  border-color: darkgoldenrod;
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.outdated {
  background-color: rgba(255, 191, 191, 0.959); /* light purple */
  color: red; /* texto morado más oscuro para contraste */
  border-color: red;
}

.closedInTime {
  background-color: rgba(191, 255, 191, 0.959); /* light purple */
  color: green; /* texto morado más oscuro para contraste */
  border-color: green;
}
</style>
